import { Box, CircularProgress, Typography, useTheme, keyframes } from '@mui/material';
import ZigyLogo from './shared/ZigyLogo';

const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

export default function LoadingVisualization() {
  const theme = useTheme();

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        width: '100%',
        gap: 8,
        backgroundColor: 'var(--bg-page-default)',
        animation: `${fadeIn} 0.5s ease-out`,
      }}
    >
      {/* Logo */}
      <Box>
        <ZigyLogo width={120} height={45} />
      </Box>

      {/* Spinner */}
      <CircularProgress
        size={70}
        thickness={3.5}
        sx={{
          color: theme.palette.primary.main,
        }}
      />

      {/* Loading Text */}
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: 0.5,
        }}
      >
        <Typography
          variant="h5"
          color="text.primary"
          sx={{
            fontWeight: 600,
          }}
        >
            Putting on my thinking cap… 🤔
        </Typography>
      </Box>
    </Box>
  );
}
